import { useReopenCompleteVqq } from "./useReopenCompleteVqq";
import { createReopenVqqFeedbackHandlers } from "../utils/reopenVqqFeedback";
import { createDetailsReopenFeedbackHandlers } from "../utils/reopenVqqUi";
import { isVqqReopenFeatureEnabled } from "../utils/reopenVqqFeature";

/** My VQQs / grid action-menu reopen flow (toast + local notification). */
export function useReopenVqqMenuFlow({
  status,
  details,
  userRole,
  questionnaireId,
  enabled = true,
  rfiActionToast,
  setLocalNotificationError,
  setShowNotification,
  setMessage,
  refetch,
}) {
  return useReopenCompleteVqq({
    status,
    details,
    userRole,
    questionnaireId,
    enabled: isVqqReopenFeatureEnabled() && enabled,
    ...createReopenVqqFeedbackHandlers({
      rfiActionToast,
      setLocalNotificationError,
      setShowNotification,
      setMessage,
      refetch,
    }),
  });
}

/** VQQ Details overview reopen flow (status notification + dual refetch). */
export function useReopenVqqDetailsFlow({
  status,
  details,
  userRole,
  questionnaireId,
  enabled = true,
  setNotificationStatus,
  setUpdateNotificationOpen,
  setMessage,
  refetch,
  activityRefetch,
}) {
  return useReopenCompleteVqq({
    status,
    details,
    userRole,
    questionnaireId,
    enabled: isVqqReopenFeatureEnabled() && enabled,
    ...createReopenVqqFeedbackHandlers(
      createDetailsReopenFeedbackHandlers({
        setNotificationStatus,
        setUpdateNotificationOpen,
        setMessage,
        refetch,
        activityRefetch,
      })
    ),
  });
}
